export const siteConfig = {
  name: "宅宅资源库",
  slogan: "合集 · 索引 · 归档",
  description:
    "以合集、索引、归档形式整理各类资源，整理贴持续补全并更新目录，让找资源更有条理。",
  email: "hello@zhaizhai-archive.example.com",
  categories: [
    { key: "anime", name: "动画合集", desc: "按系列整理的动画片源、剧场版与特典归档" },
    { key: "manga", name: "漫画合集", desc: "按作者与作品整理的漫画卷宗与单行本索引" },
    { key: "game", name: "游戏合集", desc: "单机、独立与经典游戏资源系列整理" },
    { key: "novel", name: "轻小说合集", desc: "文库本、网络连载与设定集归档索引" },
    { key: "voice", name: "声优资料", desc: "按声优整理的出演作品与角色索引" },
    { key: "fanwork", name: "同人归档", desc: "同人图、画集与创作者作品补全目录" },
  ],
  nav: [
    { key: "home", name: "首页", path: "/" },
    { key: "collections", name: "合集", path: "/collections" },
    { key: "archive", name: "归档", path: "/archive" },
    { key: "about", name: "关于", path: "/about" },
    { key: "faq", name: "常见问题", path: "/faq" },
  ],
};

export const heroImages = {
  heroBanner:
    "https://readdy.ai/api/search-image?query=editorial%20magazine%20archive%20collage%20with%20warm%20cream%20paper%20background%2C%20stacked%20books%20manga%20volumes%20and%20posters%2C%20terracotta%20and%20amber%20tone%20ink%20illustration%2C%20soft%20studio%20lighting%2C%20minimalist%20composition%20with%20generous%20negative%20space&width=1600&height=760&seq=hero-zhai-001&orientation=landscape",
};